import Vue from 'vue'
import App from './App.vue'
import * as AppKit from '@/utils/http/AppHttpKit';
import * as Dialog from '@/utils/DialogUtils';
import * as Navigator from '@/utils/NavigatorUtils';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueRouter from 'vue-router'
import routers from '@/routers'
import VueCodeMirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import {getLocalStorageItem} from '@/utils/localstorage/LocalstorageKit'
import IM from './utils/im/zj-im-sdk.umd.min.js'
import * as echarts from 'echarts'
import store from '@/store/index';
import * as filters from '@/filters/index'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.use(VueRouter);
Vue.use(VueCodeMirror);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$appGet=AppKit.get
Vue.prototype.$appPostJson=AppKit.postJSON
Vue.prototype.$appPostForm=AppKit.postForm

Vue.prototype.$wsKit=IM.WsKit
Vue.prototype.$echarts = echarts
Vue.prototype.$confirmDialog = Dialog.confirmDialog
Vue.prototype.$errorMsg = Dialog.errorMsg
Vue.prototype.$successMsg = Dialog.successMsg

Vue.prototype.$navigator = Navigator.navTo
Vue.prototype.$queryParam = Navigator.queryParam




const router = new VueRouter({
  mode: 'history',
  base:"/",
  routes: routers
})

//路由守卫，用来检查当前用户是否登录系统
router.beforeEach((to,from,next)=>{
  let token = getLocalStorageItem("token");
  let isLogin = (token)?true:false;
  if(to.path == '/login' || isLogin){
    console.log(to.path)
    next();
  }else{
    next('/login');
  }
})

initErrorReportForVue(Vue,"千里眼监控平台")
new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
